(function () {
  'use strict';

  angular.module("lif.filters").filter("link", linkFilter);
  linkFilter.$inject = [];

  function linkFilter() {
    return function (input) {
      var isEmailRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

      if (isEmailRegex.test(input)) {
        return "mailto:" + input;
      }

      return input;
    };
  }

  ;
})();